// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iznj","content":"styles_content__1z-gF"};